import BaseServiceCrud from './BaseServiceCrud';

export default class CompanyService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'company';
    }
    get() {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getCurrency() {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/currency`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getActiveCompaniesForSuperAdmin() {
        return this.fetch(`${this.domain}/${this.path}/super-admin/active`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getCompanySetting(settingType) {
        return this.fetch(`${this.domain}/${this.path}/settings/${settingType}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
